import { render, staticRenderFns } from "./OstaTable.vue?vue&type=template&id=cfa4fd98&"
import script from "./OstaTable.vue?vue&type=script&lang=js&"
export * from "./OstaTable.vue?vue&type=script&lang=js&"
import style0 from "./OstaTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports